import DSDialogContent from '../design-system/DSDialogContent';
import { DSTypography } from '../design-system/Typography';
import DSDialogActions from '../design-system/DSDialogActions';
import DSSecondaryButton from '../design-system/DSSecondaryButton';
import DSPrimaryButton from '../design-system/DSPrimaryButton';
import DSDialog from '../design-system/DSDialog';
import { SxProps, Theme } from '@mui/material';

type WarningDialogProps = {
  warningMessage: string;
  open: boolean;
  handleConfirmationClick: () => void;
  handleClose: () => void;
  isConfirmDisabled?: boolean;
  warningNote?: string;
  sx?: SxProps<Theme>;
};
const WarningDialog = ({
  warningMessage,
  open,
  handleConfirmationClick,
  handleClose,
  isConfirmDisabled,
  warningNote,
  sx,
}: WarningDialogProps) => {
  return (
    <DSDialog maxWidth="md" open={open} onClose={handleClose} sx={sx}>
      <DSDialogContent>
        <DSTypography
          variant="body2"
          color="text.primary"
          sx={{ whiteSpace: 'pre-line' }}
        >
          {warningMessage}
        </DSTypography>
        {warningNote && (
          <DSTypography
            variant="caption"
            color="error"
            sx={{ mt: 1, display: 'block' }}
          >
            {warningNote}
          </DSTypography>
        )}
      </DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton onClick={() => handleClose()}>
          Cancel
        </DSSecondaryButton>
        <DSPrimaryButton
          onClick={() => handleConfirmationClick()}
          disabled={isConfirmDisabled}
        >
          Yes
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};
export default WarningDialog;
